import { pick } from '@shared/lib/collections'

import { useDemoShiftControlStore } from './store'
import { useSlotsTrackerApi } from '../../api/demo-slots/slots-tracker.hook'

interface ButtonFiltersClearReturn {
  disabled: ComputedRef<boolean>
  setClear: () => Promise<void>
}

export const useButtonFiltersClear = (): ButtonFiltersClearReturn => {
  const router = useRouter()
  const demoShiftControlStore = useDemoShiftControlStore()

  const disabled = computed(() => demoShiftControlStore.isShiftControlBusy)

  const setClear = async (): Promise<void> => {
    demoShiftControlStore.setFilterReservationType(null)
    demoShiftControlStore.setFilterSlotStatus(null)
    demoShiftControlStore.setFilterSortBy(null)

    const query = pick({
      ...demoShiftControlStore.getFilterParams,
      current_page: String(demoShiftControlStore.getCurrentPage),
      per_page: String(demoShiftControlStore.getPerPage),
    })

    await router.push({ query })

    await useSlotsTrackerApi()
  }

  return {
    disabled,
    setClear,
  }
}
